/* eslint-disable no-unused-vars */
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { ClickAwayListener, MenuItem, Popper, Button, Modal, Box } from '@mui/material';
import Spinner from '../../../layout/spinner/spinner';
import { persistor } from '../../../store/store';
import { clearAllReduxStates } from '../../../utils/common-hooks/clearState';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import leftArrow from "../../../assets/images/new/left.svg";
import ContactFormHubspot from '../login/hubspot/contactForm';
import "../../../components/static/sidebar/sidebar.scss";
import "./viewDashboardTableau.scss";
import "../login/login.scss";
import { setLogoutSession } from '../../../services/slices/authTokenSlice';
import { responseData } from '../../../utils/helpers/helper';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import StableTooltip from '../view-dashboard/stableTooltip';
const ViewDashboardTableau = () => {
    const location = useLocation();
    const navigate = useNavigate()
    const { authTokenResponseData } = useSelector((state) => state.authToken);
    const { dashboardData } = useSelector((state) => state?.dashboardData);
    const { mymarket } = useSelector((state) => state.MyMarket);
    const { shopName = [] } = useSelector((state) => state?.source?.sourceDatas);
    const { shopStatus } = useSelector((state) => state?.shopStatus);
    const isWelcomeNewUser = mymarket?.isMarketAvailable !== undefined;
    const anchorElRef1 = useRef(null);
    const [anchorElRef, setAnchorElRef] = useState(null);
    const [tableauShopName, setTableauShopName] = useState("");
    const [openPopper, setOpenPopper] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [shopNames, setShopNames] = useState([]);
    const [allShopNames, setAllShopNames] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedShop, setSelectedShop] = useState('');
    const [activeLibrary, setActiveLibrary] = useState("");
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isLoadingTableau, setIsLoadingTableau] = useState(false);
    const [analyticsFetchError, setAnalyticsFetchError] = useState('');
    const [rateParityPop, setRateParityPop] = useState(false);
    const [shopnameSelected, setShopnameSelected] = useState("");
    const [emptyLibrary, setEmptyLibrary] = useState(false);
    const [popMessage, setPopMessage] = useState('');
    const [editShop, setEditShop] = useState({ open: false, title: [] })
    const [contactOpen, setContactOpen] = useState(false);
    const dispatch = useDispatch();
    const groups = useSelector(state => state.MarketGroup?.marketGroup);

    useEffect(() => {
        const dashboardDetails = dashboardData?.filter(res => res?._id === location?.state?.dashboardId);
        const sortShops = shops => [...shops]?.sort((a, b) => (a?.shopName ?? '').localeCompare(b?.shopName ?? ''));
        const setInitialShop = (shops) => {
            const sortedShops = sortShops(shops);
            const shopId = sortedShops?.[0];
            const InitaialId = location?.state?.fsId ? location?.state?.fsId : shopId?.fsId
            if (location?.state && location?.state?.groupName && location?.state?.groupName !== "" && groups?.length > 0) {
                const groupshopIds = groups.find((grp) => grp?.groupName.toLowerCase() === location?.state?.groupName.toLowerCase()).fsIds;
                const shopIds = groupshopIds.map((i) => parseInt(i.fsId));
                const filteredShops = sortedShops.filter((res) => shopIds.includes(res?.fsId));
                setShopNames(filteredShops);
                setAllShopNames(sortedShops);
            } else {
                setShopNames(sortedShops);
                setAllShopNames(sortedShops);
            }
            setSelectedShop(location?.state?.fsId ? location?.state?.fsId : shopId?.fsId);
            setTableauShopName(location?.state?.fsId ? location?.state?.shopName || "" : shopId?.shopName || "");
            getEmbedUrl(location?.state?.libraryId, InitaialId);
        };

        if (dashboardDetails?.length) {
            if (dashboardDetails?.[0]?.allShops) {
                const filteredShop = shopName?.filter((res) => res?.status === shopStatus);
                const filterVisualize = filteredShop?.filter((itm) => itm?.isVisualizeShop === true);
                setInitialShop(filterVisualize);
            } else {
                const filterShops = [...new Set(dashboardDetails[0].groupDetails?.flatMap(res => res?.fsIds))];
                const filteredShop = shopName?.filter((res) => res?.status === shopStatus)
                const shopNameOptions = filteredShop?.filter(res => filterShops.includes(res?.fsId));
                const filterVisualize = shopNameOptions?.filter((itm) => itm?.isVisualizeShop === true);
                setInitialShop(filterVisualize);
            }
        } else {
            const filteredShop = shopName?.filter((res) => res?.status === shopStatus)
            const filterVisualize = filteredShop?.filter((itm) => itm?.isVisualizeShop === true);
            setInitialShop(filterVisualize);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.state?.libraryId, shopName, shopStatus])

    const disposeExistingVizInstances = async () => {
        // Dispose of existing Viz instances
        const vizs = window.tableau.VizManager.getVizs();
        if (vizs.length > 0) {
            for (const viz of vizs) {
                await viz.dispose();
            }
        }
    }
    // Fetch tableau url
    const getEmbedUrl = async (libraryid, shopid) => {
        disposeExistingVizInstances()
        setIsLoading(true)
        setAnalyticsFetchError('')
        const url = `${process.env.REACT_APP_API_URL}${'gettableau'}`
        const payload =
        {

            libraryId: libraryid,
            shopId: parseInt(shopid),
            group: selectedGroup === '' ? "Default" : parseInt(selectedGroup),
            isAdmin: !!authTokenResponseData?.isImpersonated
        }
        try {
            const responses = await axios.post(url, payload);
            const response = await responseData(responses)
            setIsLoading(false)
            initTableau({ url: response?.accessUrl })
            return response?.accessUrl;
        } catch (error) {
            if (error?.response?.status === 401 && responseData(error?.response)?.message === "New login found.") {
                dispatch(setLogoutSession(true));
            } else if (error?.response?.status === 401) {
                clearAllReduxStates(dispatch)
                persistor.purge();
                sessionStorage.clear();
                localStorage.clear();
                navigate("/")
            }
            console.error('Error fetching details:', error);
            setIsLoading(false)
            // The chart is being republished on the user's Tableau site (API responds 409 + preparing)
            const isPreparing = error?.response?.status === 409 && responseData(error?.response)?.preparing
            setAnalyticsFetchError(isPreparing ? 'preparing' : true)
            throw error;
        }
    }

    const handleMarkSelection = () => {

    };

    const listenIsLoadingTableau = () => {
        setTimeout(() => {
            if (isLoading) {
                setIsLoading(false)
            }

        }, 6000);
    };

    const listenIsLoadingTableauload = () => {
        setTimeout(() => {
            if (isLoadingTableau) {
                setIsLoadingTableau(false)
            } else {
                setIsLoadingTableau(false)
            }
        }, 6000);
    };

    const isIncognito = async () => {
        try {
            localStorage.setItem('testKey', 'testValue');
            localStorage.removeItem('testKey');
            return false; // Not in incognito mode
        } catch (e) {
            return true; // In incognito mode
        }
    }

    // Initialize tableau iframe
    const initTableau = async ({ from, retryCount = 3, url }) => {
        const vizOptions = from === "myshop" ? {
            hideTabs: true,
            hideToolbar: false,
            showShareOptions: false,
            device: 'default',
            Fsid: parseInt(selectedShop),
            ...(selectedGroup !== null && selectedGroup !== "Default" && selectedGroup
                ? { groupid: parseInt(selectedGroup) }
                : {}),
            onFirstInteractive: () => {
                // Code to run when the viz has finished loading
                setIsLoadingTableau(false)
            },
        } : {
            hideTabs: true,
            hideToolbar: false,
            showShareOptions: false,
            device: 'default',
            onFirstInteractive: () => {
                // Code to run when the viz has finished loading
                setIsLoadingTableau(false)
            },
        };
        let viz;
        const containerDiv = document.getElementById('tableauVizContainer');

        // Create a new Viz instance
        viz = new window.tableau.Viz(containerDiv, `${url}&:showShareOptions=false`, vizOptions);

        try {
        } catch (error) {
            if (retryCount > 0) {
                setTimeout(() => {
                    initTableau({ retryCount: retryCount - 1 });
                }, 500);
            } else if (isIncognito()) {
                setIsLoading(false)
                setIsLoadingTableau(false)
            }
            else {
                setIsLoading(false)
                setIsLoadingTableau(false)
            }
            return;
        }
        // Show loading
        listenIsLoadingTableau();
        listenIsLoadingTableauload()
        if (viz) {
            // Remove the event listener before attaching a new one
            viz.removeEventListener(window.tableau.TableauEventName.MARKS_SELECTION, handleMarkSelection);

            // Attach a new event listener
            viz.addEventListener(window.tableau.TableauEventName.MARKS_SELECTION, handleMarkSelection);
        }
    }

    const handleOpenPopper = (event, type) => {
        event.stopPropagation();
        setAnchorElRef(anchorElRef1.current);
        setOpenPopper((prev) => !prev);
    };

    const handleClickAway = (event) => {
        if (
            anchorElRef.current &&
            !anchorElRef.current.contains(event.target) &&
            event.target.closest('.MuiPopper-root') === null
        ) {
            setOpenPopper(false);
        }
        setSearchValue("");
        if (location?.state && location?.state?.groupName && location?.state?.groupName !== "" && groups?.length > 0) {
            const groupshopIds = groups.find((grp) => grp?.groupName.toLowerCase() === location?.state?.groupName.toLowerCase()).fsIds;
            const shopIds = groupshopIds.map((i) => parseInt(i.fsId));
            const filteredShops = allShopNames.filter((res) => shopIds.includes(res?.fsId));
            setShopNames(filteredShops);
            setAllShopNames(filteredShops);
        } else {
            setShopNames(allShopNames);
        }
        setOpenPopper(false);

    };

    const handleGoBack = (e) => {
        navigate("/view_dashboard", {
            state: {
                fsId: location?.state?.fsId,
                from: "mymarket",
                groupid: "Default",
                libraryName: location?.state?.libraryName,
                libraryId: location?.state?.libraryId,
                dashboardId: location?.state?.dashboardId,
                groupName: location?.state?.groupName || ""
            }
        })
    }

    const handleSelectedShop = (e, res) => {
        setSelectedShop(res?.fsId);
        setTableauShopName(res?.shopName)
        getEmbedUrl(location?.state?.libraryId, res?.fsId);
        handleClickAway();
    }

    const isSelected = (shops, id) => {
        return shops?.includes(id);
    }

    const handleSearchShops = (e) => {
        setSearchValue(e.target.value)
        if (e.target.value !== "") {
            const serachValue = allShopNames?.filter((res) => res?.shopName.toLowerCase()?.includes(e.target.value.toLowerCase()));
            if (location?.state &&location?.state?.groupName && location?.state?.groupName !== "" && groups?.length > 0) {
                const groupshopIds = groups.find((grp) => grp?.groupName.toLowerCase() === location?.state?.groupName.toLowerCase()).fsIds;
                const shopIds = groupshopIds.map((i) => parseInt(i.fsId));
                const filteredShops = serachValue.filter((res) => shopIds.includes(res?.fsId));
                setShopNames(filteredShops);
            }
            setShopNames(serachValue);
        } else {
            if (location?.state && location?.state?.groupName && location?.state?.groupName !== "" && groups?.length > 0) {
                const groupshopIds = groups.find((grp) => grp?.groupName.toLowerCase() === location?.state?.groupName.toLowerCase()).fsIds;
                const shopIds = groupshopIds.map((i) => parseInt(i.fsId));
                const filteredShops = allShopNames.filter((res) => shopIds.includes(res?.fsId));
                setShopNames(filteredShops);
                setAllShopNames(filteredShops);
            } else {
                setShopNames(allShopNames);
            }
        }
    }

    const handleOpenContact = () => setContactOpen(true);
    const handleCloseContact = () => setContactOpen(false);

    return (
        <div >
            {(isLoading || isLoadingTableau) && <Spinner />}
            <div className="single-library-tableau">
                <div className=" no-translate">
                    <div className="view-library no-translate">
                        <div className="back-to-library">
                            <Button onClick={(e) => handleGoBack(e)} title="Return to Routes Overview">
                                <img src={leftArrow} alt="back-to-library" /> {location?.state?.libraryName}
                            </Button>
                            {location?.state?.description && <StableTooltip description={location?.state?.description} />}
                        </div>
                        <div className={isWelcomeNewUser === true ? "dontselect filters" : "filters"} >
                            <div
                                ref={anchorElRef1}
                                className={`custom-select arrow-filed ${tableauShopName !== "" ? "active-filter" : ""}`}
                                onClick={(e) => handleOpenPopper(e, "shopName")}>
                                {tableauShopName !== "" ? `Shop: ${tableauShopName}` : 'Select Shops'}
                                {openPopper === true ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                            </div>
                        </div>
                    </div>
                </div>

                {!editShop?.open ?
                    rateParityPop ? (
                        <div className="contact-support">
                            <div className="text-center">
                                <p>The {activeLibrary} is not available for this shop.In order to obtain it please add {popMessage.join(", ")} to the shop {shopnameSelected}
                                </p>
                                <p>
                                    Sincerely,<br />
                                    Faretrack support team.
                                </p>
                            </div>
                            <div id="tableauVizContainer" width='100%' className="tableauclass d-none" ></div>

                        </div>) : emptyLibrary ? (
                            <div className="contact-support">
                                <div className="text-center">
                                    <p>Library is not selected for this shop. In order to obtain it, please add at least one library to the shop group.</p>
                                    <p>
                                        Sincerely,<br />
                                        Faretrack support team.
                                    </p>
                                </div>
                                <div id="tableauVizContainer" width='100%' className="tableauclass d-none" ></div>
                            </div>
                        ) : (
                        <div className="tableau-main-page">
                            {analyticsFetchError === 'preparing' && (
                                <div className="contact-support">
                                    <div className="text-center">
                                        <p>
                                            This chart is being prepared. Please try again in a few minutes.
                                        </p>
                                    </div>
                                </div>
                            )}
                            {analyticsFetchError && analyticsFetchError !== 'preparing' && (
                                <div className="contact-support">
                                    <div className="text-center">
                                        <p>
                                            Oops! The dashboard is currently unavailable. We apologize for the inconvenience.
                                            <br />Please try reloading the page, or if the issue persists, <span type="button" onClick={handleOpenContact} style={{ color: '#FF914E', cursor: "pointer" }}>contact our support team</span> for assistance.
                                            <br />Thank you for your patience!
                                        </p>
                                        <p>
                                            Sincerely,<br />
                                            Faretrack support team.
                                        </p>
                                    </div>
                                </div>
                            )}
                            {!emptyLibrary && (
                                <div id="tableauVizContainer" style={{ width: '100%', height: '600px' }} ></div>
                            )}
                        </div>
                    ) : ""
                }
            </div>
            <ClickAwayListener onClickAway={handleClickAway}>
                <Popper
                    open={openPopper}
                    anchorEl={anchorElRef}
                    placement="bottom-start"
                    sx={{ maxHeight: "10rem", overflow: "scroll", zIndex: 3 }}
                    className="menus-container" >
                    <div className="route-search flex-box-button">
                        <input type="text" value={searchValue} onChange={(e) => handleSearchShops(e)} placeholder="Search by shops name" />
                    </div>
                    <>
                        {shopNames?.length > 0 ? (
                            shopNames?.map((res, index) => (
                                <MenuItem
                                    key={index}
                                    value={res}
                                    onClick={(e) => handleSelectedShop(e, res)}
                                    sx={{
                                        backgroundColor: anchorElRef1.current === anchorElRef ? isSelected([res?.fsId], selectedShop) ? '#d9e2e5' : '#fff' : '#fff',
                                        zIndex: 2,
                                    }}
                                >
                                    {res?.shopName}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem>No Options</MenuItem>
                        )}
                    </>
                </Popper>
            </ClickAwayListener>

            <Modal backdrop={"static"} open={!!contactOpen} className="ticket-modal">
                <Box className="boxmodal ticketsystem">
                    <div className="headermodal">
                        <h1>Contact Form<Button type="button" onClick={handleCloseContact}>x</Button></h1>
                    </div>
                    <div className="headerbody">
                        <ContactFormHubspot />
                    </div>
                </Box>
            </Modal>
        </div>
    );
}

export default ViewDashboardTableau;